import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CurrentUserService } from '../services/current-user.service';
import { ProjectsApiService } from '../services/projects-api.service';
import { LoggerService } from '../services/logger.service';

// project_engineer can edit Draft (0) and Pending Additional Information (5).
export const projectEditStatusGuard: CanActivateFn = async route => {
  const currentUserService = inject(CurrentUserService);
  const projectsApi = inject(ProjectsApiService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  await currentUserService.load();

  if (!currentUserService.hasAnyRole(['project_engineer', 'project_engineers'])) {
    return true;
  }

  const readonlyParam = route.queryParamMap.get('readonly')?.trim().toLowerCase();
  const isReadonlyQuestionnaire = route.routeConfig?.path === 'questionnaire'
    && (readonlyParam === 'true' || readonlyParam === '1' || readonlyParam === 'yes');

  // Allow questionnaire access in explicit readonly mode for project engineers.
  if (isReadonlyQuestionnaire) {
    return true;
  }

  const projectIdParam = route.queryParamMap.get('projectId');
  if (!projectIdParam) {
    return true;
  }

  const projectId = Number(projectIdParam);
  if (!Number.isInteger(projectId) || projectId <= 0) {
    return true;
  }

  try {
    const project = await firstValueFrom(projectsApi.getProjectById(projectId));
    if (project.projectStatusType === 0 || project.projectStatusType === 5) {
      return true;
    }
  } catch (error) {
    // If project cannot be loaded, keep user out of edit forms.
    logger.error(`Failed to load project ${projectId} for access control`, error);
  }

  return router.createUrlTree(['/view-request'], { queryParams: { projectId } });
};